import React from 'react'

const Error = (props) => {
	return(
		<div className="error-msg">This is subscribed via {props.args}. Management should be done from the subscribed device</div>
	)
}


export default Error;